import { Button, Modal, message } from "antd";
import React, { useState } from "react";
import { getAPIDateFormat } from "../../utils/date.utils";
import { fetchOtaAvailableRoutesUrl } from "./get-ota-url.module";

export const GetOtaUrl = (props) => {

    const {
        origin,
        destination,
        date
    } = props;

    const [isModalVisible, setModalVisible] = useState(false);
    const [otaUrl, setOtaUrl] = useState("");

    const showModal = () => {
        fetchOtaAvailableRoutesUrl(
            {
                origin,
                destination,
                date: getAPIDateFormat(date)
            },
            (url) => {
                setOtaUrl(url);
                setModalVisible(true);
            },
            () => {
                message.error("Failed to get OTA URL");
            }
        );
    }

    const handleCancel = () => {
        setModalVisible(false);
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(otaUrl)
            .then(() => message.success("OTA URL copied"))
            .catch(() => message.error("Failed to copy OTA URL"));
    }

    return (
        <div>
            <Button
                onClick={showModal}
                className="bordered-btn send-driver-details-btn"
            >Get OTA URL</Button>
            <Modal
                title={"OTA URL"}
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <div style={{ wordBreak: 'break-all', marginBottom: '12px' }}>
                    <a href={otaUrl} target="_blank" rel="noopener noreferrer">{otaUrl}</a>
                </div>
                <Button className="bordered-btn" onClick={handleCopy}>Copy URL</Button>
            </Modal>
        </div>
    )
}
